import { Box, Button, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import AdminNavbar from "../components/nav-bar";
import PeerReviewers from "../components/peer-reviewers";
import PendingPeerReviews from "../components/pending-peer-reviews";
import PendingEditorialBoard from "../components/pending-editoral-board";
import EditorialBoard from "../components/editorial-board";

function EditorialBoardHome() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get("status");
    
    return (
        <Box>
            <AdminNavbar/>
            
            <Box sx={{ padding: 2 }}>
              {status === '0' && <PendingEditorialBoard/>}
              {status === '1' && <EditorialBoard/>}
            </Box>
        </Box>
    );
}

export default EditorialBoardHome;
